import type {
  LibraryCMSFile,
  LibraryCMSLink,
  LibraryChallenge,
  LibraryGuide,
  LibraryResource,
  LibrarySeries,
  LibraryTopLevelContent,
} from '../types';
import Urls from '~/urls';
import { LibraryTopLevelContentTypes } from '../constants';

export const startGuide = (guide: LibraryGuide, openInNewTab: boolean = false) => {
  const guideAssignment = guide.assignments[0];
  const guideStarted = guideAssignment?.numCompletedTasks > 0;
  const continueGuideUrl = Urls.guideContinueAssignment(guideAssignment?.id, guide.libraryId, guide.folderId);
  const startGuideUrl = Urls.guideStart(guide.guideId, guide.libraryId, guide.folderId);
  const guideUrl = guideStarted ? continueGuideUrl : startGuideUrl;
  const target = openInNewTab ? '_blank' : '_self';
  window.open(guideUrl, target);
};

export const adminGuideOverview = (guide: LibraryGuide) => {
  window.location.assign(`/admin/guides/${guide.guideId}`);
};

export const previewGuide = (guide: LibraryGuide) => {
  const params = `?university_id=${encodeURI(guide.libraryId)}&uguide_id=${encodeURI(guide.id)}`;
  const path = `/guides/${guide.guideId}/preview/`;
  window.location.assign(path + params);
};

export const startSCORM = (scorm: LibraryTopLevelContent, openInNewTab: boolean = false) => {
  const url = Urls.topLevelContentStartOrContinueAssignment(
    'scorm',
    scorm.topLevelContentId,
    scorm.libraryId,
    scorm.folderId,
  );
  const target = openInNewTab || scorm.openInNewTab ? '_blank' : '_self';
  window.open(url, target);
};

export const adminSCORMOverview = (tlc: LibraryTopLevelContent) => {
  window.location.assign(`/admin/content/scorm/${tlc.topLevelContentId}`);
};

export const adminContentProviderContentOverview = (tlc: LibraryTopLevelContent) => {
  window.location.assign(`/admin/content/content_provider_content/${tlc.topLevelContentId}`);
};

export const viewResource = (resource: LibraryResource, openInNewTab: boolean = false) => {
  const url = Urls.resource(resource.resourceId, resource.libraryId, resource.id);
  const target = openInNewTab ? '_blank' : '_self';
  window.open(url, target);
};

export const viewContentProviderContent = (content: LibraryTopLevelContent) => {
  window.open(content.contentLink, '_blank');
};

export const adminResourceOverview = (resource: LibraryResource) => {
  window.location.assign(`/admin/resources/${resource.resourceId}`);
};

export const adminCmsOverview = (content: LibraryCMSFile | LibraryCMSLink) => {
  window.location.assign(`/admin/cms/${content.cmsAsset.assetType.toLocaleLowerCase()}/${content.cmsAsset.id}`);
};

export const learnerGoToCmsContent = (content: LibraryCMSFile | LibraryCMSLink) => {
  if (content.contentType === LibraryTopLevelContentTypes.CMS_FILE) {
    window.open(`/cms_files/view?id=${content.cmsAsset.id}`, '_self');
  } else if (content.contentType === LibraryTopLevelContentTypes.CMS_LINK) {
    window.open(`/cms_links/view?id=${content.cmsAsset.id}`, '_blank');
  }
};

export const startChallenge = (challenge: LibraryChallenge, openInNewTab: boolean = false) => {
  let url = Urls.challengeNewOrGoToFromUniversity(challenge.libraryId, challenge.challengeId);
  const challengeAssignment = challenge.assignments[0];
  if (challengeAssignment) {
    url = Urls.challengeContinueAssignment(challengeAssignment.id, challenge.libraryId, challenge.folderId);
  }
  const target = openInNewTab ? '_blank' : '_self';
  window.open(url, target);
};

export const previewChallenge = (challenge: LibraryChallenge) => {
  const params = `?university_id=${encodeURI(challenge.libraryId)}&uchallenge_id=${encodeURI(challenge.id)}`;
  const path = `/challenges/${challenge.challengeId}/preview/`;
  window.location.assign(path + params);
};

export const adminChallengeOverview = (challenge: LibraryChallenge) => {
  window.location.assign(`/admin/challenges/${challenge.challengeId}`);
};

export const previewSeries = (series: LibrarySeries) => {
  const href = Urls.pathPreview(series.seriesId, series.libraryId, series.folderId);
  window.location.assign(href);
};

export const startSeries = (series: LibrarySeries) => {
  const path = `/paths/${series.seriesId}/start`;
  let params = series.libraryId ? `?university_id=${series.libraryId}` : '';

  if (series.folderId) {
    params = params.concat(`&university_folder_id=${series.folderId}`);
  }
  window.open(path + params, '_blank');
};

export const adminSeriesOverview = (series: LibrarySeries) => {
  window.location.assign(`/admin/paths/${series.seriesId}`);
};
